module.exports = __webpack_public_path__ + "static/media/arrow-left.d6b7c89a.svg";